export default __webpack_public_path__ + "73be31f1b6d8d03bad95540ee121bc9d.png";